"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
let default_1 = class default_1 extends _vuePropertyDecorator.Vue {
  constructor() {
    super(...arguments);
    // endTime: string = '2024-05-07T10:53:43.700Z';
    this.timer = null;
    this.timeRemaining = '';
  }
  mounted() {
    this.startTimer();
  }
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }
  startTimer() {
    this.timer = setInterval(() => {
      const now = new Date().getTime();
      const end = new Date(this.endTime).getTime();
      const distance = end - now;
      if (distance <= 0) {
        if (this.timer) {
          clearInterval(this.timer);
        }
        this.timeRemaining = 'Time expired';
      } else {
        const days = Math.floor(distance / (1000 * 60 * 60 * 24));
        const hours = Math.floor(distance % (1000 * 60 * 60 * 24) / (1000 * 60 * 60));
        const minutes = Math.floor(distance % (1000 * 60 * 60) / (1000 * 60));
        const seconds = Math.floor(distance % (1000 * 60) / 1000);
        if (days > 0) {
          this.timeRemaining = `${days}d ${hours}h ${minutes}m ${seconds}s`;
        } else if (hours > 0) {
          this.timeRemaining = `${hours}h ${minutes}m ${seconds}s`;
        } else if (minutes > 0) {
          this.timeRemaining = `${minutes}m ${seconds}s`;
        } else {
          this.timeRemaining = `${seconds}s`;
        }
      }
    }, 1000);
  }
};
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  default: false
})], default_1.prototype, "endTime", void 0);
default_1 = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'FollowUpTimer',
  components: {}
})], default_1);
var _default = exports.default = default_1;